"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPause,
  faVolumeUp,
  faVolumeMute,
  faExpand,
  faCompress,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./CustomControls.module.css";

const CustomControls = ({
  playing,
  togglePlay,
  muted,
  toggleMute,
  volume,
  handleVolumeChange,
  playbackRate,
  handlePlaybackRateChange,
  speedControlId,
  toggleFullscreen,
  isFullscreen,
}) => {
  return (
    <div
      className={styles.controlsOverlay}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.topLeftControls}>
        <button
          type="button"
          className={styles.controlButton}
          onClick={toggleMute}
          aria-label={muted || volume === 0 ? "Unmute" : "Mute"}
          title={muted || volume === 0 ? "Unmute" : "Mute"}
        >
          <FontAwesomeIcon
            icon={muted || volume === 0 ? faVolumeMute : faVolumeUp}
          />
        </button>
        <input
          type="range"
          min={0}
          max={1}
          step="0.01"
          value={volume}
          onChange={handleVolumeChange}
          className={styles.volumeSlider}
          style={{ '--volume-progress': `${volume * 100}%` }}
          aria-label="Volume"
        />
      </div>

      <button
        type="button"
        className={`${styles.controlButton} ${styles.fullscreenButton}`}
        onClick={toggleFullscreen}
        aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
      >
        <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
      </button>

      <button
        type="button"
        className={styles.playButton}
        onClick={togglePlay}
        aria-label={playing ? "Pause" : "Play"}
        title={playing ? "Pause" : "Play"}
      >
        <FontAwesomeIcon icon={playing ? faPause : faPlay} />
      </button>

      <div className={styles.speedContainer}>
        <label className={styles.speedLabel} htmlFor={speedControlId}>
          Playback speed <span>{playbackRate.toFixed(2)}×</span>
        </label>
        <input
          id={speedControlId}
          type="range"
          min="0.05"
          max="1.0"
          step="0.05"
          value={playbackRate}
          onChange={handlePlaybackRateChange}
          className={styles.speedSlider}
          style={{ '--speed-progress': `${playbackRate * 100}%` }}
        />
      </div>
    </div>
  );
};

export default CustomControls;
